/* eslint-disable no-console */
import React, { useEffect, useState, useCallback } from 'react';
import { useStyles, TableControl, InputContainer, InputSelect } from './styles';
import {
  Backdrop,
  CircularProgress,
  Icon,
  IconButton,
  TableCell,
  Tooltip,
} from '@material-ui/core';
import Layout from 'shared/component/Layout';
import DefaultTable from 'shared/component/DefaultTable';
import TabPanel from 'shared/component/tabPanel';
import SearchInputDebounce from 'shared/component/forms/SearchInputDebounce';
import { AvatarNameComponent } from 'shared/component/AvatarNameComponent';
import CustomSelect from 'shared/component/forms/CustomSelect';
import '../../shared/fixedtab.css';
import moment from 'moment';
import StatusChip from 'shared/component/StatusChip';
import useReport from 'hook/report';
import HasPermission from 'utils/checkPermission';
import { ModalResponseAlert } from 'page/Schedule/WeekSchedule/components/ModalResponseAlert';
import useUnit from 'hook/unit';
import { useRef } from 'react';

export default function UsersWithoutSubscription() {
  const classes = useStyles();

  const permissions = {
    read: 'report/r',
  };

  const columns = () => {
    return [
      {
        id: 'name',
        label: 'Nome',
        minWidth: 100,
        render: (rowData, index) => (
          <AvatarNameComponent key={index} rowData={rowData} />
        ),
      },
      { id: 'cpf', label: 'CPF', minWidth: 100 },
      { id: 'group.name', label: 'Campo de atuação', minWidth: 100 },
      {
        id: 'company.name',
        label: 'Companhia',
        minWidth: 100,
      },
      {
        id: 'unit',
        label: 'Hospital',
        minWidth: 100,
        render: (rowData, index) => (
          <SpecialtiesNames key={index} specialties={rowData?.units} />
        ),
      },
      {
        id: 'created_at',
        label: 'Data de criação',
        minWidth: 10,
        render: (rowData) => (
          <TableCell>
            {moment(rowData.created_at).format('DD/MM/yyyy')}
          </TableCell>
        ),
      },
      {
        id: 'status',
        label: 'Status',
        minWidth: 10,
        render: (rowData, index) => (
          <StatusChip key={index} rowData={rowData} />
        ),
      },
    ];
  };

  const SpecialtiesNames = ({ specialties }) => {
    if (!specialties || !(specialties.length > 0))
      return <TableCell>...</TableCell>;
    const concatedNames = specialties.map((item) => item?.name).join(' , ');
    return <TableCell>{concatedNames}</TableCell>;
  };

  const {
    dataProfessional,
    loading: loadingProfessionals,
    totalProfessional,
    getProfessionalsWithoutSignature,
    getExcelUserWithoutSignature,
  } = useReport();
  const { units, getUnits } = useUnit();

  const [unitSelected, setUnitSelected] = React.useState();
  const pageRef = useRef(1);
  const { loadingUnits, dataUnits, totalUnits } = units;
  const [loadingExcel, setLoadingExcel] = useState(false);

  const [filterUnit, filterStateUnit] = useState({
    unitPage: 1,
    unitPerPage: 30,
    unitSearch: '',
  });
  const { unitPage, unitPerPage, unitSearch } = filterUnit;

  const [filterProfessionals, setFilterProfessionals] = useState({
    page: 1,
    search: '',
    per_page: 10,
    status: 'all',
    unit_id: '',
  });

  const [profissionalStatus, setProfissionalStatus] = useState({
    label: 'Todos',
    value: 'all',
  });

  const [openModalSendNotification, setOpenModalSendNotification] =
    useState(false);

  const handleChangeProfessionalStatus = useCallback((val) => {
    setProfissionalStatus(val);
    setFilterProfessionals((oldState) => ({
      ...oldState,
      status: val?.value,
      page: 1,
    }));
  }, []);

  const unitPagination = () => {
    const nextPage = pageRef.current + 1;
    const totalPage = Math.ceil(totalUnits / unitPerPage);
    if (pageRef.current < totalPage) {
      filterStateUnit({ ...filterUnit, unitPage: nextPage });

      pageRef.current = nextPage;
    }
  };

  useEffect(() => {
    const { page, search, per_page, status, unit_id } = filterProfessionals;
    getProfessionalsWithoutSignature({
      page,
      search,
      per_page,
      status,
      unit_id,
    });
  }, [filterProfessionals]);

  useEffect(() => {
    getUnits(unitPage, unitPerPage, unitSearch);
  }, [unitPage, unitSearch]);
  const handleChangePage = (page) => {
    setFilterProfessionals({ ...filterProfessionals, page: page });
  };

  const handleSearch = (search) => {
    typeof search === 'string'
      ? setFilterProfessionals((old) => ({ ...old, page: 1, search }))
      : false;
  };

  const handleOpenExcel = async () => {
    setLoadingExcel(true);
    try {
      await getExcelUserWithoutSignature({ ...filterProfessionals });
    } catch (error) {
      console.error('Erro ao exportar Excel:', error);
    } finally {
      setLoadingExcel(false);
    }
  };

  const handleCloseModal = () => {
    setOpenModalSendNotification(false);
  };
  const searchUnit = (unitValue) => {
    filterStateUnit({ ...filterUnit, unitSearch: unitValue });
  };

  const formatUnitsOptions = dataUnits.map((company) => ({
    label: company.name,
    value: company.id,
  }));
  const topUnitPagination = () => {
    const previousPage = pageRef.current - 1;
    if (pageRef.current > 1) {
      filterStateUnit({ ...filterUnit, unitPage: previousPage });

      pageRef.current = previousPage;
    }
  };

  const handleChangeUnit = (val) => {
    setUnitSelected(val);
    setFilterProfessionals({
      ...filterProfessionals,
      unit_id: val?.value,
      search: '',
      page: 1,
    });
  };

  const typeProfessionalStatus = [
    { label: 'Todos', value: 'all' },
    { label: 'Ativos', value: 'active' },
    { label: 'Inativos', value: 'deactive' },
    { label: 'Em moderação', value: 'moderating' },
    { label: 'Deletados', value: 'deleted' },
  ];

  return (
    <Layout title="Profissionais sem assinatura" showToday backArrow>
      <div style={{ margin: '0 0px 0 30px', backgroundColor: '#EDEDED' }}>
        <div
          data-cy="div_professional_filters"
          className={classes.inputContainer}
        >
          <InputContainer>
            <SearchInputDebounce
              value={filterProfessionals.search}
              className={classes.inputWidth}
              placeholder="Busque por nome ou CPF"
              onChange={handleSearch}
              style={{
                flex: 1,
                alignItems: 'center',
                height: 48,
                width: '100%',
              }}
            />
          </InputContainer>

          <InputSelect>
            <CustomSelect
              isProf={false}
              name="unit_id"
              loading={loadingUnits}
              placeholder="Selecione o hospital"
              handleChange={handleChangeUnit}
              value={unitSelected}
              searchItem={searchUnit}
              pagination={unitPagination}
              toTopPagination={topUnitPagination}
              options={formatUnitsOptions}
              isClearable
            />
          </InputSelect>
          <InputSelect>
            <CustomSelect
              isProf={false}
              name="status"
              loading={false}
              placeholder="Selecione o status do profissional"
              handleChange={handleChangeProfessionalStatus}
              className={classes.withoutBorder}
              value={profissionalStatus}
              options={typeProfessionalStatus}
            />
          </InputSelect>
          <Backdrop
            open={loadingExcel}
            style={{ zIndex: 1500, color: '#fff', flexDirection: 'column' }}
          >
            <CircularProgress color="inherit" />
            <div style={{ marginTop: 20 }}>Gerando arquivo Excel...</div>
          </Backdrop>
          {HasPermission(permissions.export) ? (
            <Tooltip title="EXPORTAR EXCEL" placement="bottom" arrow>
              <IconButton
                onClick={handleOpenExcel}
                style={{ padding: 0, marginTop: 0 }}
              >
                <Icon style={{ fontSize: 30, color: '#0F83AD' }}>
                  article_outlined
                </Icon>
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Você não tem permissão" placement="bottom" arrow>
              <IconButton
                style={{
                  padding: 0,
                  marginTop: 0,
                }}
              >
                <Icon style={{ fontSize: 30, color: '#9D9DA9' }}>
                  article_outlined
                </Icon>
              </IconButton>
            </Tooltip>
          )}
          <ModalResponseAlert
            messageTitleAlert="Não há profissionais para exportar no período informado!"
            openSendFinish={openModalSendNotification}
            handleCloseSendFinish={handleCloseModal}
            error
          />
        </div>

        <div className={classes.root}>
          <TabPanel>
            <TableControl data-cy="dataTable">
              <DefaultTable
                permissions={permissions}
                dataList={dataProfessional}
                pageByProps={filterProfessionals.page}
                columns={columns()}
                loading={loadingProfessionals}
                totalList={totalProfessional}
                perPage={filterProfessionals?.perPage}
                handleChangePage={handleChangePage}
                showExportButton={false}
                showActions={false}
                useTimeOut={false}
                pageStorageKey="userWithoutSubscriptionPage"
              />
            </TableControl>
          </TabPanel>
        </div>
      </div>
    </Layout>
  );
}
